export default __webpack_public_path__ + "static/media/mode-17.7b949799.svg";